<template lang="pug">
  y-dialog(v-if="showModal" v-model='showModal', scrollable='', max-width='600px' persistent)
    v-card
      v-card-title
        div.h6.basic800--text {{ $t('edit_message_template') }}
      v-divider.basic300
      v-card-text.pt-4
        v-form(ref="extraform")
          p.mb-2.label.basic600--text.text-uppercase {{ $t('message.label') }}
          v-textarea.mt-4(ref="textarea" v-model='finalMessage' background-color="basic200" :placeholder="$t('message.placeholder')" hide-details outlined dense @input="updateCursor" @change="updateCursor" @focus="updateCursor" auto-grow)
          .guide.mt-4.c1.primary400--text
            div {{ $t('tips_format_text') }}: 
              div.ml-2 1. 
                span(style="font-style: italic") Italic: 
                b  _text_
              div.ml-2 2. 
                span(style="font-weight: bold") Bold: 
                b  *text*
              div.ml-2 3. 
                span(style="text-decoration: line-through") Strikethrough
                b : ~text~
              div.ml-2 4. 
                span(style="font-family: 'Courier New', Courier, monospace") Monospace: 
                b  ```text```
            div.caption
              span {{ $t('source') }}:
              a.text-decoration-none.textColorAccent--text.ml-2(href="https://faq.whatsapp.com/general/chats/how-to-format-your-messages" target="_blank") WhatsApp
          div.my-3.label.basic600--text.text-uppercase {{ $t('insert_field') }}: 
          .field-type
            v-layout.mt-1
              v-item-group
                v-item.mb-2
                  v-btn.text-capitalize.mr-1(small height=24 outlined @click="insertValue('name')") {{ $t('name') }}
                v-item.mb-2
                  v-btn.text-capitalize.mx-1(small height=24 outlined @click="insertValue('phone')") {{ $t('phone') }}
                v-item.mb-2
                  v-btn.text-capitalize.mx-1(small height=24 outlined @click="insertValue('email')") {{ $t('email') }}
                v-item.mb-2
                  v-btn.text-capitalize.mx-1(small height=24 outlined @click="insertValue('products_description')") Products
                v-item.mb-2
                  v-btn.text-capitalize.mx-1(small height=24 outlined @click="insertValue('store_link')") {{ $t('invoice_link') }}
                v-item.mb-2(v-for='(field, index) in fields' :key="index")
                  v-btn.text-capitalize.mx-1(small height=24 outlined @click="insertValue(`extra_${index}`)") {{ field.name }} ({{index}})
          .live-view.my-4(v-if="finalMessage")
            v-card.pa-4(outlined)
              div.s1.basic1000--text.mb-4 {{ $t('message_preview') }}:
              div(class="message" v-html="formatInput(formattedMessage)")

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='updateTemplate' )
          .button-AA-small.basic100--text {{ $t('update') }}

</template>

<script>
export default {
  name: 'AddWaMessageTemplateDialog',
  props: ['open', 'fields', 'hasProduct', 'message'],
  data: () => ({
    finalMessage: '',
    cursorPosition: 0,
    textarea: null
  }),
  mounted () {
    this.textarea = this.$refs.textarea.$el.querySelector('textarea')
    if (this.message) {
      this.finalMessage = this.message
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    formattedMessage () {
      if (this.finalMessage) {
        let message = this.finalMessage
        message = message.split('{{name}}').join('Customer Name')
        message = message.split('{{phone}}').join('60111111111')
        message = message.split('{{email}}').join('example@gmail.com')
        message = message.split('{{products_description}}').join('1. Burger (x1)<br> - cheese (x1)')
        message = message.split('{{store_link}}').join('https://yezza.store/example')
        let largestIndex = 0
        message.split('{{').forEach(word => { 
          word.split('}}').forEach(w => {
            if (w.includes('extra_')) {
              const index = parseInt(w.split('_')[1])
              if (largestIndex < index) {
                largestIndex = index
              }
            }
          })
        })
        for (var i = 0; i < largestIndex + 1; i++) {
          if (this.fields && this.fields.length > i) {
            let field = this.fields[i]
            message = message.split(`{{extra_${i}}}`).join(field.name)
          } else {
            message = message.split(`{{extra_${i}}}`).join('')
          }
        }        
        return message
      }
      return this.finalMessage
    }
  },
  methods: {
    updateCursor () {
      const postion = this.textarea.selectionStart
      if (!postion) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue (value) {
      this.finalMessage = `${this.finalMessage.substring(0, this.cursorPosition)}{{${value}}}${this.finalMessage.substring(this.cursorPosition, this.finalMessage.length)}`
    },
    updateTemplate() {
      if (!this.$refs.extraform.validate()) {
        return
      }
      this.$emit('update:message', this.finalMessage)
      this.showModal = false
    },
    formatInput(string) {
      string = String(string);
      
      //-----> for bold text
      let bold = string.split(" ").map((word) =>
      {
        if (/\*/.test(word) && !/^\**$/.test(word))
          if (/(^(~\*)|^(_\*)|^\*)(.*)(\*$|(\*_)$|(\*\W)$)/.test(word))
            return word.replace(/\*([^\r\n]+)\*/g, "<b>$1</b>")
          else if (/[_*~]\*(.*)\*[~*_]/.test(word))
            return word.replace(/\*([^*][^\r\n]+[^*])\*/g, "<b>$1</b>");
        return word;
      }).join(" ");

      //-----> for italic text 
      let italic = bold.split(" ").map((word) =>
      {
        if (/_/.test(word) && !/^_+$/.test(word))
        if (/(^~_|^_<.*>|^_\*|^_)(.*)(_$|(_<.*>)$|(_\*)$|(_\W)$)/.test(word))
          return word.replace(/_([^\r\n]+)_/g, "<i>$1</i>");
        else if (/(~|_|\*|<.*>)_(.*)_(<.*>|\*|~|_)/.test(word))
          return word.replace(/_([^_][^\r\n]+[^_])_/g, "<i>$1</i>");
        return word;
      }).join(" ");
      
      //----->for strikethrough/deleted text 
      let strikethrough = italic.split(" ").map((word) =>
      {
        if (/~/.test(word) && !/^~+$/.test(word))
          if (/(^_~|^~<.*>|^\*~|^~)(.*)(~$|(~_)$|(~<.*>)$|(~\*)$|(~\W)$)/.test(word))
            return word.replace(/~([^\r\n]+)~/g, "<del>$1</del>")
          else if (/(~|_|\*|<.*>)~(.*)~(<.*>|\*|~|_)/.test(word))
            return word.replace(/~([^~][^\r\n]+[^~])~/g, "<del>$1</del>");
        return word;
      }).join(" ");
      
      
      
      //-----> for underlined text
      var underline = strikethrough.split(" ").map(function(word)
      {
        if (/%/.test(word) && !/^%+$/.test(word))
          if (/(^_%|^~%|^%<.*>|^\*%|^%)(.*)(%$|(%~)$|(%_)$|(%<.*>)$|(%\*)$|%\W+$)/.test(word))
            return word.replace(/%([^\r\n]+)%/g, "<u>$1</u>")
          else if (/(%|~|_|\*|<.*>)%(.*)%(<.*>|\*|~|%|_)/.test(word))
            return word.replace(/%([^%][^\r\n]+[^%])%/g, "<u>$1</u>");
        return word;
      }).join(" ");
      
      
      
      //-----> for monospace text
      var monospace = underline.split(" ").map(function(word)
      {
        if (/```/.test(word))
          if (/```(.|\n|\r)*(.+)(.|\n|\r])*```/.test(word)) 
            return word.replace(/```((.|\n|\r)*(.*)(\r|\n|.)*)```/g, `<span style="font-family: 'Courier New', Courier, monospace">$1</span>`);
        return word;
      }).join(" ");
        
      var formatted = monospace;
      
      //-----> for bold sentence formatting
      if (/\*(.*)\*/.test(formatted))
        formatted = formatted.replace(/(^|[\s_>~%`])\*([^\s\r\n]+[^*\n\r]+[^\s\r\n]+)\*([\W_\r\n\s]|$)/g, "$1<b>$2</b>$3");


      //-----> for italic sentence formatting 
      if (/_(.*)_/.test(formatted))
        formatted = formatted.replace(/(^|[\s>~%`*])_([^\s\r\n]+[^_\n\r]+[^\s\n\r]+)_([\W_\s\r\n]|$)/g, "$1<i>$2</i>$3");
      
      
      //-----> for strikethrough sentence formatting 
      if (/~(.*)~/.test(formatted))
        formatted = formatted.replace(/(^|[\s>%`*_])~([^\s\r\n]+[^~\r\n]+[^\r\n\s]+)~([\W_\s\r\n]|$)/g, "$1<del>$2</del>$3");
      
      
      //-----> for underline sentence formatting 
      if (/%(.*)%/.test(formatted))
        formatted = formatted.replace(/(^|[\s>~`*_])%([^\s\r\n]+[^%\r\n]+[^\r\n\s]+)%([\W_\s\r\n]|$)/g, "$1<u>$2</u>$3");
    
    
      //-----> for monospace sentence formatting
      var counter = 0;
      if (/```/.test(formatted))
      {
        var i = 0;
        formatted = formatted.split(" ");
        formatted = formatted.map(function(word)
        {
          //tempArr[i+1] handles case where input is like this: ``` ``` with no characters between back ticks
          if (!/<code>/.test(word))
            if (/```/.test(word) && formatted[i+1] != "```")
            {
              i++; counter++;
              if (counter % 2 != 0) 
                return word.replace("```", "<code>");
              else
                return word.replace("```", "</code>");
            } i++; 
          return word;
        }).join(" ");

        //handles case where there are no closing back ticks
        if (counter % 2 == 1)
        {
          formatted = formatted.split(" ");
          for (i = formatted.length-1; i >= 0; i--)
            if (/<code>/.test(formatted[i]))
            {
              formatted[i] = formatted[i].replace(/<code>/, "```");
              break;
            }
          formatted = formatted.join(" ");
        }
      }
      return formatted;
    }
  }
}
</script>

<style scoped>
.message {
  white-space: pre-wrap;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "message": {
      "label": "Message Template",
      "placeholder": "Hi, I'm {{name}},\n\ninterested to buy\n{{product_description}}\n\nBuy now? Order here : {{store_link}}",
      "edit_message_template": "Edit Message Template",
      "tips_format_text": "Tips to Format Text in WhatsApp"
    }
  },
  "id": {
    "message": {
      "label": "Template Pesanan",
      "placeholder": "Hi, saya {{name}},\n\nTertarik untuk membeli\n{{product_description}}\n\nBeli sekarang? Pesan di sini : {{store_link}}",
      "edit_message_template": "Ubah Template Pesan",
      "tips_format_text": "Tips Memformat Teks di Whatsapp"
    }
  }
}
</i18n>
